export const SET_COMPONENTS = "SET_COMPONENTS";

export const ADD_COMPONENTS = "ADD_COMPONENTS";

export const ADD_COMPONENTS_TO_FLAT_LIST = "ADD_COMPONENTS_TO_FLAT_LIST";

export const DELETE_COMPONENT_TO_FLAT_LIST = "DELETE_COMPONENT_TO_FLAT_LIST";

export const TOGGLE_ADD_COMPONENT_DIALOG = "TOGGLE_ADD_COMPONENT_DIALOG";

export const SET_SELECTED_COMPONENT = "SET_SELECTED_COMPONENT";

export const TOGGLE_EXPAND = "TOGGLE_EXPAND";

export const TOGGLE_CONTEXT_MENU = "TOGGLE_CONTEXT_MENU";

export const TOGGLE_DELETE_COMPONENT_DIALOG = "TOGGLE_DELETE_COMPONENT_DIALOG";

export const DELETE_COMPONENT = "DELETE_COMPONENT";

export const TOGGLE_COMPONENT_ENABLE_DISABLE_DIALOG = "TOGGLE_COMPONENT_ENABLE_DISABLE_DIALOG";

export const TOGGLE_COMPONENT_HIDDEN = "TOGGLE_COMPONENT_HIDDEN";

export const TOGGLE_RESET_COMPONENT_DIALOG = "TOGGLE_RESET_COMPONENT_DIALOG";